import {Spacing} from '../../Styles';
import {CalculateElevation} from '../../Utils/Elevation';
import {ThemedStyleSheet} from '../../Utils/ThemedStyleSheet';

export default ThemedStyleSheet((theme) => ({
  container: {
    paddingVertical: Spacing.normal,
  },
  card: {
    backgroundColor: theme.colors.surface,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: theme.colors.border,
    padding: Spacing.small,
    ...CalculateElevation(1, '#000'),
  },
  intro: {
    color: theme.colors.textLight,
    marginBottom: Spacing.small,
  },
  optionRow: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.colors.border,
    backgroundColor: theme.colors.surfaceSecondary,
    paddingHorizontal: Spacing.xsmall,
    paddingVertical: Spacing.xsmall,
    marginBottom: Spacing.xsmall,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  selectedOptionRow: {
    borderColor: theme.colors.primary,
    backgroundColor: theme.colors.backgroundSecondary,
  },
  optionLabel: {
    color: theme.colors.text,
  },
  currentRegionText: {
    color: theme.colors.textStrong,
    marginBottom: Spacing.small,
  },
  localityTitle: {
    color: theme.colors.textStrong,
    marginTop: Spacing.small,
    marginBottom: Spacing.xsmall,
  },
  saveButton: {
    marginTop: Spacing.small,
    borderRadius: 12,
  },
}));
